module.exports = __webpack_public_path__ + "img/truck.3f70f4ae.png";